const RESPONSE = {
  NO_NEVER: -1,
  CANCEL: 0,
  CREATE_REPORT: 1,
  ADD_SERIES: 2,
  SET_STUDY_AND_SERIES: 3,
  NO_NOT_FOR_SERIES: 4,
};

function promptTrackNewSeries({ servicesManager, extensionManager }, ctx, evt) {
  const { UIViewportDialogService } = servicesManager.services;
  const { viewportIndex, StudyInstanceUID, SeriesInstanceUID } = evt;

  return new Promise(async function (resolve, reject) {
    /*IMPLEMENTADO*/
    /* Remoção da confirmação de rastrear série */

    // let promptResult = await _askShouldAddMeasurements(
    //   UIViewportDialogService,
    //   viewportIndex
    // );

    let promptResult = RESPONSE.ADD_SERIES;

    if (promptResult === RESPONSE.CREATE_REPORT) {
      promptResult = ctx.isDirty
        ? await _askSaveDiscardOrCancel(UIViewportDialogService, viewportIndex)
        : RESPONSE.SET_STUDY_AND_SERIES;
    }

    resolve({
      userResponse: promptResult,
      StudyInstanceUID,
      SeriesInstanceUID,
      viewportIndex,
      isBackupSave: false,
    });
  });
}

function _askShouldAddMeasurements(uiViewportDialogService, viewportIndex) {
  return new Promise(function (resolve, reject) {
    const message =
      'Deseja adicionar esta medição ao relatório existente?';
    const actions = [
      { type: 'cancel', text: 'Cancelar', value: RESPONSE.CANCEL },
      {
        type: 'secondary',
        text: 'Criar novo relatório',
        value: RESPONSE.CREATE_REPORT,
      },
      {
        type: 'primary',
        text: 'Adicionar ao relatório existente',
        value: RESPONSE.ADD_SERIES,
      },
    ];
    const onSubmit = result => {
      uiViewportDialogService.hide();
      resolve(result);
    };

    uiViewportDialogService.show({
      viewportIndex,
      type: 'info',
      message,
      actions,
      onSubmit,
      onOutsideClick: () => {
        uiViewportDialogService.hide();
        resolve(RESPONSE.CANCEL);
      },
    });
  });
}

function _askSaveDiscardOrCancel(UIViewportDialogService, viewportIndex) {
  return new Promise(function (resolve, reject) {
    const message =
      'Você tem medições rastreadas existentes. O que você gostaria de fazer com suas medições rastreadas existentes?';
    const actions = [
      { type: 'cancel', text: 'Cancelar', value: RESPONSE.CANCEL },
      {
        type: 'secondary',
        text: 'Salvar',
        value: RESPONSE.CREATE_REPORT,
      },
      {
        type: 'primary',
        text: 'Descartar',
        value: RESPONSE.SET_STUDY_AND_SERIES,
      },
    ];
    const onSubmit = result => {
      UIViewportDialogService.hide();
      resolve(result);
    };

    UIViewportDialogService.show({
      viewportIndex,
      type: 'warning',
      message,
      actions,
      onSubmit,
      onOutsideClick: () => {
        UIViewportDialogService.hide();
        resolve(RESPONSE.CANCEL);
      },
    });
  });
}

export default promptTrackNewSeries;
